module.exports = __webpack_public_path__ + "static/img/chapter.cbe8c60.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/images/chapter.png
// module id = pgmo
// module chunks = 1